import React from "react";
import DOMPurify from "dompurify";
import { DA_Container } from "@danishagro/shared/src/components/atoms/Container/Container.component";

interface V1Props {
    description?: string;
}

const V1 = ({ description }: V1Props) => {
    return description ? (
        <DA_Container>
            <div
                dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(description),
                }}
            />
        </DA_Container>
    ) : null;
};

export default V1;
